<template>
  <section class="imgInput">
    <label :class="['imgInput__card', `imgInput__card--${shape}`, selectedImage && 'imgInput__card--filled']" :for="inputId">
      <img v-if="selectedImage" class="imgInput__preview" :src="selectedImage" alt="preview" />
      <div v-if="selectedImage" class="imgInput__overlay">
        <iconic name="camera" class="imgInput__overlayIcon" />
        <span>Cambiar</span>
      </div>
      <template v-else>
        <iconic name="camera" class="imgInput__emptyIcon" />
        <span class="imgInput__emptyText">{{ labelText }}</span>
      </template>
    </label>
    <input class="imgInput__hiddenInput" type="file" ref="fileInput" :id="inputId" accept=".png,.jpg,.jpeg,.heic,.webp" @change="onFileChange" />
    <p v-if="pictureName" class="imgInput__fileName">{{ pictureName }}</p>
  </section>
</template>

<script>
  export default {
    props: {
      selectedImage: { type: String, default: null },
      pictureName: { type: String, default: null },
      inputId: { type: String, default: "profile" },
      shape: { type: String, default: "circle" },
      labelText: { type: String, default: "Seleccionar" },
      maxSizeMB: { type: Number, default: 1 },
      maxWidth: { type: Number, default: null },
      maxHeight: { type: Number, default: null },
    },
    methods: {
      async onFileChange(event) {
        if (!event.target.files.length) return;
        const file = event.target.files[0];
        if (!this.$global.validFileSize([file], this.maxSizeMB)) {
          this.$toast.error(`La imagen no debe superar los ${this.maxSizeMB}MB`);
          this.reset();
          return;
        }
        if (this.maxWidth || this.maxHeight) {
          const { width, height } = await this.getImageDimensions(file);
          if ((this.maxWidth && width > this.maxWidth) || (this.maxHeight && height > this.maxHeight)) {
            this.$toast.error(`La imagen no debe superar ${this.maxWidth} x ${this.maxHeight} (imagen: ${width} x ${height})`);
            this.reset();
            return;
          }
        }
        this.$emit("file-selected", file);
      },
      getImageDimensions(file) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          const url = URL.createObjectURL(file);
          img.onload = () => {
            URL.revokeObjectURL(url);
            resolve({ width: img.naturalWidth, height: img.naturalHeight });
          };
          img.onerror = (err) => {
            URL.revokeObjectURL(url);
            reject(err);
          };
          img.src = url;
        });
      },
      reset() {
        this.$refs.fileInput.value = "";
      },
    },
  };
</script>

<style lang="scss">
  .imgInput {
    @include Flex(column, flex-start, center);
    gap: 6px;

    &__card {
      position: relative;
      @include Flex(column);
      gap: 6px;
      border: 2px dashed #d0d0d0;
      background: #fafafa;
      cursor: pointer;
      overflow: hidden;
      transition:
        border-color 0.2s ease,
        background 0.2s ease,
        box-shadow 0.2s ease;

      &:hover {
        border-color: $primary_color;
        background: $background-card;
        box-shadow: 0 2px 12px rgba(189, 9, 9, 0.12);
      }

      &--circle {
        border: none;

        .imgInput__overlay,
        .imgInput__preview {
          border-radius: 50%;
        }
        width: 100px;
        height: 100px;
        border-radius: 50%;
        overflow: visible;

        &::before {
          content: "";
          position: absolute;
          inset: -2px;
          border-radius: 50%;
          border: 2px dashed #d0d0d0;
          pointer-events: none;
          transition: border-color 0.2s ease;
        }

        &:hover::before {
          border-color: $primary_color;
        }

        &.imgInput__card--filled::before {
          border-style: solid;
        }
      }

      &--vertical {
        width: 80px;
        height: 142px;
        border-radius: 10px;
      }

      &--filled {
        border-style: solid;
        border-color: #d0d0d0;

        &:hover {
          border-color: $primary_color;
        }
      }
    }

    &__preview {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__overlay {
      position: absolute;
      inset: 0;
      @include Flex(column);
      gap: 2px;
      background: rgba(0, 0, 0, 0.5);
      opacity: 0;
      transition: opacity 0.2s ease;
      color: #fff;
      font-size: 11px;
      font-weight: 600;

      .imgInput__card:hover & {
        opacity: 1;
      }
    }

    &__overlayIcon {
      font-size: 18px;
    }

    &__emptyIcon {
      font-size: 22px;
      color: #c0c0c0;
    }

    &__emptyText {
      font-size: 10px;
      font-weight: 500;
      color: #aaa;
      text-align: center;
      line-height: 1.3;
      padding: 0 6px;
    }

    &__hiddenInput {
      display: none;
    }

    &__fileName {
      font-size: 11px;
      color: $sec_color;
      max-width: 110px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }
  }
</style>
